import React, { useEffect, useRef, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../store/slices/categorySlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import TextInputFormik from "../../components/inputs/TextInuputformik";
import {
  deletePrestation,
  getMyEtablissement,
} from "../../store/slices/etablissementSlice";
import { useLocation, useNavigate } from "react-router-dom";
import PrestationCard from "../../pages/prestataires/prestationCard";
import { formatUpdateDate } from "../../utils/utils";
import { toast } from "react-toastify";

const ServicesPrestataire = ({ from, selectedEtablissement }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(
    from === "account" ? false : true
  );
  const location = useLocation();

  const [isCompleted, setIsCompleted] = useState(true); // Add this state
  // 1. Initialize expandedServices state properly
  const [expandedServices, setExpandedServices] = useState(() => {
    const initialState = {};
    if (selectedEtablissement?.services) {
      selectedEtablissement.services.forEach((_, index) => {
        initialState[index] = false; // Tous les services fermés par défaut
      });
    }
    return initialState;
  });
  const onSaveSuccess = () => {
    dispatch(getMyEtablissement());
  };
  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);
  // Toggle function for individual services
  const toggleService = (serviceIndex) => {
    setExpandedServices((prev) => ({
      ...prev,
      [serviceIndex]: !prev[serviceIndex],
    }));
  };
  const token = location?.state?.token || localStorage.getItem('token');
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/json',
    }
  };



  const handleSavePrestation = async (serviceId, prestations, type) => {
    setOrderLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}prestations/order/${serviceId}`,
        prestations.map((p, index) => ({
          prestation_id: p.prestationId,
          order: index + 1,
        })),
        headers
      );

      // console.log("Ordre des prestations sauvegardé");
    } catch (err) {
      // Vérifie si certaines prestations n'ont pas encore d'ID (non enregistrées)
      const hasUnsavedPrestation = prestations.some(
        (prestation) => !prestation.prestationId
      );

      const errorMessage =
        err.response?.data?.message || "Échec de l'enregistrement";

      if (type === "drag" && hasUnsavedPrestation) {
        toast.error(
          "Veuillez enregistrer toutes les prestations avant de modifier leur ordre."
        );
      }
      // else {
      //   toast.error(errorMessage);
      // }
    } finally {
      setOrderLoading(false);
    }
  };


  const handleSaveService = async (formikValues, type) => {
    setOrderLoading(true);
    const allServicesData = formikValues.services
      // .filter(service => service.serviceId != null)
      .map((service, index) => ({
        id: service.serviceId,
        name: service.name,
        order: service.order || index + 1,
        // Ajoutez d'autres champs si nécessaire
      }));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}category/order`, allServicesData,
        headers
      );
      // toast.success('Modifications enregistrées');
    } catch (err) {
      const hasUnsavedCategory = formikValues.services.some(service => !service.serviceId);

      const errorMessage = err.response?.data?.message || "Échec de l'enregistrement";

      if (type === 'drag' && hasUnsavedCategory) {
        toast.error("Veuillez enregistrer toutes les catégories avant de modifier leur ordre.");
      }
      // else {
      //   toast.error(errorMessage);
      // }
    } finally {
      setOrderLoading(false);
    }
  }
  const validationSchema = Yup.object().shape({
    services: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .required("Le nom de la catégorie est requis")
            .max(30, "Le nom de la catégorie ne doit pas dépasser 30 caractères"),
          prestations: Yup.array()
            .of(
              Yup.object().shape({
                name: Yup.string()
                  .required("Le nom de la prestation est requis")
                  .max(
                    50,
                    "Le nom de la prestation ne doit pas dépasser 50 caractères"
                  ),
                duree: Yup.string().required("La durée est requise"),
                description: Yup.string().max(
                  500,
                  "La description ne doit pas dépasser 500 caractères"
                ),
                lieu: Yup.array()
                  .min(1, "Au moins un lieu d'intervention requis")
                  .required("Les lieux d'intervention sont requis"),
                ht: Yup.number().min(0, "Le prix doit être positif"),
                taux_tva: Yup.number()
                  .min(0, "La TVA doit être positive")
                  .max(100, "La TVA ne peut pas dépasser 100%"),
              })
            )
            .min(1, "Au moins une prestation requise"),
        })
      )
      .min(1, "Au moins une catégorie requis"),
  });

  let initialValues = {
    services:
      selectedEtablissement?.services?.length > 0
        ? selectedEtablissement.services.map((service) => ({
          name: service.name || "",
          serviceId: service.id || "",
          prestations: service.prestations.map((prestation) => ({
            name: prestation.name || "",
            prestationId: prestation.id || "",
            duree: prestation.duree || "",
            nbr_sceance: prestation.nbr_sceance || 1,
            ht: prestation.ht || "",
            taux_tva: prestation.taux_tva || 20,
            ttc: prestation.ttc || "",
            description: prestation.description || "",
            lieu: prestation.lieu || [],
            prestation_complementaire:
              prestation.prestation_complementaire || [],
          })),
        }))
        : [
          {
            name: "",

            prestations: [
              {
                name: "",
                duree: "",
                nbr_sceance: 1,
                ht: "",
                taux_tva: 20,
                ttc: "",
                description: "",
                lieu: [],
                prestation_complementaire: [],
              },
            ],
          },
        ],
  };
  useEffect(() => {
    if (selectedEtablissement && !initialized) {
      initialValues = {
        services:
          selectedEtablissement?.services?.length > 0
            ? selectedEtablissement.services.map((service) => ({
              name: service.name || "",
              serviceId: service.id || "",
              prestations: service.prestations.map((prestation) => ({
                name: prestation.name || "",
                prestationId: prestation.id || "",
                duree: prestation.duree || "",
                nbr_sceance: prestation.nbr_sceance || 1,
                ht: prestation.ht || "",
                taux_tva: prestation.taux_tva || 20,
                ttc: prestation.ttc || "",
                description: prestation.description || "",
                lieu: prestation.lieu || [],
                prestation_complementaire:
                  prestation.prestation_complementaire || [],
              })),
            }))
            : [
              {
                name: "",
                prestations: [
                  {
                    name: "",
                    duree: "",
                    nbr_sceance: 1,
                    ht: "",
                    taux_tva: 20,
                    ttc: "",
                    description: "",
                    lieu: [],
                    prestation_complementaire: [],
                  },
                ],
              },
            ],
      };

      if (formikRef.current) {
        formikRef.current.resetForm({ values: initialValues });
      }
      setInitialized(true);
    }
    setIsCompleted(selectedEtablissement?.services?.length > 0);
    // console.log({isCompleted})
  }, [selectedEtablissement, initialized]);
  const handleSubmit = (values) => {
    const stepsStatus = JSON.parse(localStorage.getItem("stepsStatus")) || {};
    stepsStatus[5] = "completed";
    localStorage.setItem("stepsStatus", JSON.stringify(stepsStatus));
    navigate("/equipe");
  };

  const formikRef = useRef();
  // This will force Formik to reinitialize when selectedEtablissement changes
  useEffect(() => {
    if (selectedEtablissement && formikRef.current) {
      const newValues = {
        services:
          selectedEtablissement?.services?.length > 0
            ? selectedEtablissement.services.map((service) => ({
              name: service.name || "",
              serviceId: service.id || "",
              prestations: service.prestations.map((prestation) => ({
                name: prestation.name || "",
                prestationId: prestation.id || "",
                duree: prestation.duree || "",
                nbr_sceance: prestation.nbr_sceance || 1,
                ht: prestation.ht || "",
                taux_tva: prestation.taux_tva || 20,
                ttc: prestation.ttc || "",
                description: prestation.description || "",
                lieu: prestation.lieu || [],
                prestation_complementaire:
                  prestation.prestation_complementaire || [],
              })),
            }))
            : [
              {
                name: "",
                prestations: [
                  {
                    name: "",
                    duree: "",
                    nbr_sceance: 1,
                    ht: "",
                    taux_tva: 20,
                    ttc: "",
                    description: "",
                    lieu: [],
                    prestation_complementaire: [],
                  },
                ],
              },
            ],
      };
      formikRef.current.resetForm({ values: newValues });
    }
  }, [selectedEtablissement]);
  // Add this function in your ServicesPrestataire component
  const handleRemovePrestation = async (
    removePrestation,
    serviceIndex,
    prestationIndex,
    prestationId
  ) => {
    try {
      if (prestationId) {
        // Only call API if this is an existing prestation (has an ID)
        // console.log({prestationId})
        await dispatch(deletePrestation(prestationId));
        // Optionally show success message
        // console.log('Prestation deleted successfully');
      }

      // Remove from formik state
      removePrestation(prestationIndex);

      // // If this was the last prestation in the service, you might want to remove the service too
      // if (values.services[serviceIndex].prestations.length === 1) {
      //   // Optionally handle service removal
      // }
    } catch (error) {
      // console.error("Error removing prestation:", error);
      // Optionally show error message to user
    }
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            {from === "account" ? (
              <h4 className="grey500">
                Catégories et prestations
                <button
                  type="button"
                  className="btn btn-link p-0"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  <img
                    src={
                      isExpanded
                        ? "/images/chevron-down.svg"
                        : "/images/chevron-down.svg"
                    }
                    className={`w-6 h-6 ${!isExpanded ? "rotate180" : ""}`}
                    alt={isExpanded ? "Réduire" : "Ouvrir"}
                  />
                </button>
                {!isCompleted && selectedEtablissement ? (
                  <img
                    src="/images/notCompleted.svg"
                    alt="not completed icon"
                    className="ml-8"
                  />
                ) : (
                  ""
                )}
              </h4>
            ) : (
              <h3 className="grey500">Catégories et prestations</h3>
            )}
            {from === "account" && (
              <div className="d-flex align-items-center">
                {selectedEtablissement?.updated_at && (
                  <span className="body grey66 mr-16">
                    Dernière mise à jour:{" "}
                    {formatUpdateDate(selectedEtablissement.updated_at)}
                  </span>
                )}
              </div>
            )}
          </div>
          {isExpanded && (
            <>
              <p className="body grey66 mt-16">
                Vous pouvez créer plusieurs catégories pour structurer vos offres, puis ajouter à chacune d’elles différentes prestations qui précisent ce que vous proposez.
              </p>

              <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  setFieldValue,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <FieldArray name="services">
                      {({ push: pushService, remove: removeService }) => (
                        <>
                          <DragDropContext
                            onDragEnd={(result) => {
                              if (!result.destination) return;
                              const sourceIndex = result.source.index;
                              const destIndex = result.destination.index;
                              const items = Array.from(values.services);
                              const [moved] = items.splice(sourceIndex, 1);

                              items.splice(destIndex, 0, moved);
                              // Met à jour Formik avec le nouvel ordre
                              setFieldValue("services", items);
                              // setTimeout(() => {
                              //   handleSaveService(values);
                              // }, 1000);
                              setTimeout(() => {
                                handleSaveService({ ...values, services: items }, 'drag');
                              }, 300);

                            }}
                          >
                            <Droppable droppableId="services-droppable">
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  {values.services.map(
                                    (service, serviceIndex) => (
                                      <Draggable
                                        key={
                                          service.serviceId ||
                                          `service-${serviceIndex}`
                                        }
                                        draggableId={String(
                                          service.serviceId ||
                                          `service-${serviceIndex}`
                                        )}
                                        index={serviceIndex}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            style={{
                                              border: "1px solid #ede8e8",
                                              borderRadius: "10px",
                                              padding: "10px",
                                              marginTop: "25px",
                                              background: snapshot.isDragging
                                                ? "#fafafa"
                                                : "white",
                                              ...provided.draggableProps.style,
                                            }}
                                            className="service-container mb-32"
                                          >
                                            {/* En-tête avec le drag handle sur toute la zone */}
                                            <div
                                              {...provided.dragHandleProps}
                                              className="d-flex justify-content-between align-items-center mb-16 mt-16"
                                              style={{ cursor: "grab" }}
                                            >
                                              <h4 className="grey500">
                                                {!orderLoading ? (
                                                  <img
                                                    src="/images/drag.svg"
                                                    alt="Déplacer"
                                                    style={{
                                                      width: "20px",
                                                      height: "20px",
                                                      marginRight: "10px",
                                                      verticalAlign: "middle",
                                                    }}
                                                  />
                                                ) : <img
                                                  src="/images/Loading_2.gif"
                                                  alt="Déplacer"
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    marginRight: "10px",
                                                    verticalAlign: "middle",
                                                  }}
                                                />}
                                                {service.name ||
                                                  `Catégorie ${serviceIndex + 1}`}
                                              </h4>
                                              <button
                                                type="button"
                                                className="link-blue p-0"
                                                onClick={() =>
                                                  toggleService(serviceIndex)
                                                }
                                                aria-label={
                                                  expandedServices[serviceIndex]
                                                    ? "Collapse catégorie"
                                                    : "Expand catégorie"
                                                }
                                                style={{
                                                  background: "transparent",
                                                  border: "none",
                                                  padding: 4,
                                                }}
                                              >
                                                <svg
                                                  width="18"
                                                  height="18"
                                                  viewBox="0 0 24 24"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  style={{
                                                    transform: expandedServices[
                                                      serviceIndex
                                                    ]
                                                      ? "rotate(0deg)"
                                                      : "rotate(180deg)",
                                                    transition:
                                                      "transform 0.2s",
                                                  }}
                                                  aria-hidden="true"
                                                >
                                                  <path
                                                    d="M6 9l6 6 6-6"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </svg>
                                              </button>
                                            </div>

                                            <Field
                                              type="hidden"
                                              name={`services[${serviceIndex}].order`}
                                              value={serviceIndex + 1}
                                            />

                                            {expandedServices[serviceIndex] ===
                                              true && (
                                                <>
                                                  <TextInputFormik
                                                    label="Nom de la catégorie*"
                                                    name={`services[${serviceIndex}].name`}
                                                    value={service.name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={
                                                      touched.services?.[
                                                        serviceIndex
                                                      ]?.name &&
                                                      errors.services?.[
                                                        serviceIndex
                                                      ]?.name
                                                    }
                                                    maxLength={30}
                                                  />
                                                  <h5 className="grey500 mt-24">
                                                    Prestations liées à la catégorie
                                                  </h5>

                                                  <FieldArray
                                                    name={`services[${serviceIndex}].prestations`}
                                                  >
                                                    {({
                                                      push: pushPrestation,
                                                      remove: removePrestation,
                                                    }) => (
                                                      <>
                                                        <DragDropContext
                                                          //   onDragEnd={(result) => {
                                                          //     // Vérifier si le drag concerne les prestations (et non les services)
                                                          //     if (
                                                          //       !result.destination ||
                                                          //       !result.source.droppableId.startsWith(
                                                          //         "prestations-"
                                                          //       )
                                                          //     )
                                                          //       return;

                                                          //     const sourceIndex =
                                                          //       result.source.index;
                                                          //     const destIndex =
                                                          //       result.destination
                                                          //         .index;

                                                          //     // Extraire l'index du service depuis l'ID du droppable
                                                          //     const serviceIdx =
                                                          //       parseInt(
                                                          //         result.source.droppableId.split(
                                                          //           "-"
                                                          //         )[1]
                                                          //       );

                                                          //     const items =
                                                          //       Array.from(
                                                          //         values.services[
                                                          //           serviceIdx
                                                          //         ].prestations
                                                          //       );
                                                          //     const [moved] =
                                                          //       items.splice(
                                                          //         sourceIndex,
                                                          //         1
                                                          //       );
                                                          //     items.splice(
                                                          //       destIndex,
                                                          //       0,
                                                          //       moved
                                                          //     );

                                                          //     // Mettre à jour Formik avec le nouvel ordre
                                                          //     setFieldValue(
                                                          //       `services[${serviceIdx}].prestations`,
                                                          //       items
                                                          //     );
                                                          // }}

                                                          onDragEnd={(result) => {
                                                            if (
                                                              !result.destination ||
                                                              !result.source.droppableId.startsWith("prestations-")
                                                            ) return;

                                                            const sourceIndex = result.source.index;
                                                            const destIndex = result.destination.index;

                                                            // Récupère l'index du service concerné
                                                            const serviceIdx = parseInt(
                                                              result.source.droppableId.split("-")[1]
                                                            );

                                                            const items = Array.from(values.services[serviceIdx].prestations);
                                                            const [moved] = items.splice(sourceIndex, 1);
                                                            items.splice(destIndex, 0, moved);

                                                            // Met à jour Formik
                                                            setFieldValue(
                                                              `services[${serviceIdx}].prestations`,
                                                              items
                                                            );

                                                            // Sauvegarde l'ordre en base
                                                            setTimeout(() => {
                                                              handleSavePrestation(
                                                                values.services[serviceIdx].serviceId,
                                                                items,
                                                                'drag'
                                                              );
                                                            }, 300);

                                                          }}
                                                        >
                                                          <Droppable
                                                            droppableId={`prestations-${serviceIndex}`}
                                                          >
                                                            {(provided) => (
                                                              <div
                                                                ref={
                                                                  provided.innerRef
                                                                }
                                                                {...provided.droppableProps}
                                                                className="mt-16"
                                                              >
                                                                {service.prestations.map(
                                                                  (
                                                                    prestation,
                                                                    prestationIndex
                                                                  ) => {
                                                                    const currentPrestationKey = `${serviceIndex}-${prestationIndex}`;
                                                                    return (
                                                                      <Draggable
                                                                        key={
                                                                          prestation.prestationId ||
                                                                          `prestation-${currentPrestationKey}`
                                                                        }
                                                                        draggableId={String(
                                                                          prestation.prestationId ||
                                                                          `prestation-${currentPrestationKey}`
                                                                        )}
                                                                        index={
                                                                          prestationIndex
                                                                        }
                                                                      >
                                                                        {(
                                                                          provided,
                                                                          snapshot
                                                                        ) => (
                                                                          <div
                                                                            ref={
                                                                              provided.innerRef
                                                                            }
                                                                            {...provided.draggableProps}
                                                                            style={{
                                                                              marginBottom:
                                                                                "16px",
                                                                              background:
                                                                                snapshot.isDragging
                                                                                  ? "#f5f5f5"
                                                                                  : "white",
                                                                              ...provided
                                                                                .draggableProps
                                                                                .style,
                                                                            }}
                                                                          >
                                                                            <PrestationCard
                                                                              orderLoading={orderLoading}
                                                                              dragHandleProps={
                                                                                provided.dragHandleProps
                                                                              }
                                                                              onSaveSuccess={
                                                                                onSaveSuccess
                                                                              }
                                                                              key={
                                                                                currentPrestationKey
                                                                              }
                                                                              prestation={
                                                                                prestation
                                                                              }
                                                                              prestationIndex={
                                                                                prestationIndex
                                                                              }
                                                                              serviceIndex={
                                                                                serviceIndex
                                                                              }
                                                                              handleChange={
                                                                                handleChange
                                                                              }
                                                                              handleBlur={
                                                                                handleBlur
                                                                              }
                                                                              touched={
                                                                                touched
                                                                              }
                                                                              errors={
                                                                                errors
                                                                              }
                                                                              setFieldValue={
                                                                                setFieldValue
                                                                              }
                                                                              values={
                                                                                values
                                                                              }
                                                                              removePrestation={(
                                                                                prestationIndex
                                                                              ) =>
                                                                                handleRemovePrestation(
                                                                                  removePrestation,
                                                                                  serviceIndex,
                                                                                  prestationIndex,
                                                                                  prestation.prestationId
                                                                                )
                                                                              }
                                                                              allPrestations={values.services.flatMap(
                                                                                (
                                                                                  s
                                                                                ) =>
                                                                                  s.prestations.map(
                                                                                    (
                                                                                      p
                                                                                    ) => ({
                                                                                      label:
                                                                                        p.name,
                                                                                      value:
                                                                                        p.prestationId,
                                                                                    })
                                                                                  )
                                                                              )}
                                                                              currentPrestationKey={
                                                                                currentPrestationKey
                                                                              }
                                                                              serviceName={
                                                                                service.name
                                                                              }
                                                                              serviceId={
                                                                                service.serviceId
                                                                              }
                                                                              service={
                                                                                service
                                                                              }
                                                                              prestationId={
                                                                                prestation?.prestationId
                                                                              }
                                                                              lieuEtablissement={
                                                                                selectedEtablissement?.lieu_intervention
                                                                              }
                                                                            />
                                                                          </div>
                                                                        )}
                                                                      </Draggable>
                                                                    );
                                                                  }
                                                                )}
                                                                {
                                                                  provided.placeholder
                                                                }
                                                              </div>
                                                            )}
                                                          </Droppable>
                                                        </DragDropContext>

                                                        <button
                                                          type="button"
                                                          className="twyny-cta-secondary w-100 mt-16"
                                                          onClick={() =>
                                                            pushPrestation({
                                                              name: "",
                                                              duree: "",
                                                              nbr_sceance: 1,
                                                              ht: "",
                                                              taux_tva: 20,
                                                              ttc: "",
                                                              description: "",
                                                              lieu: [],
                                                              prestation_complementaire:
                                                                [],
                                                            })
                                                          }
                                                        >
                                                          <svg
                                                            width="14"
                                                            height="14"
                                                            viewBox="0 0 24 24"
                                                            style={{
                                                              marginRight: 8,
                                                            }}
                                                            aria-hidden="true"
                                                          >
                                                            <path
                                                              d="M12 5v14M5 12h14"
                                                              stroke="currentColor"
                                                              strokeWidth="2"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            />
                                                          </svg>
                                                          Ajouter une prestation
                                                        </button>
                                                        <br></br>
                                                        <button
                                                          className="twyny-cta-primary w-100"
                                                          style={{ marginTop: '20px' }}
                                                          onClick={() => { handleSaveService(values, 'cta') }}
                                                          type="button"
                                                        >
                                                          Enregistrer la catégorie
                                                        </button>
                                                      </>
                                                    )}
                                                  </FieldArray>
                                                </>
                                              )}
                                          </div>
                                        )}
                                      </Draggable>
                                    )
                                  )}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>

                          <div className="mt-32">
                            <button
                              type="button"
                              className="twyny-cta-secondary btn-withIcon w-100"
                              onClick={() =>
                                pushService({
                                  name: "",
                                  prestations: [
                                    {
                                      name: "",
                                      duree: "",
                                      nbr_sceance: 1,
                                      ht: "",
                                      taux_tva: 20,
                                      ttc: "",
                                      description: "",
                                      lieu: [],
                                      prestation_complementaire: [],
                                    },
                                  ],
                                })
                              }
                            >
                              <img
                                src="/images/plus-01.svg"
                                className="arrow mr-8"
                                alt="Add"
                              />
                              Ajouter une catégorie
                            </button>
                          </div>
                        </>
                      )}
                    </FieldArray>
                  </form>
                )}
              </Formik>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ServicesPrestataire;
